import React, { Component } from 'react'
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image'
import "./Main.css";
import { LinkContainer } from 'react-router-bootstrap';
import {Redirect} from 'react-router-dom';

export default class Main extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoading: false,
            isCorrect: false,
            clicked: false,
            firstLoaded: false,
            firstAnswer: false,
            hasLoadedLastQuestion: false,
            correctCtr: "",
            sv: {},
            corrEntryCountry: {},
            lat: 0,
            lng: 0,
            svPath: "",
            counter: 0,
            buttons: ["one", "two", "three"],
            countryCodes: { AL: "Albania", DZ: "Algeria", AD: "Andorra", AT: "Austria", BY: "Belarus", BE: "Belgium", BA: "Bosnia and Herzegovina", BG: "Bulgaria", HR: "Croatia", CY: "Cyprus", CZ: "Czech Republic", DK: "Denmark", EE: "Estonia", FI: "Finland", FR: "France", DE: "Germany", GI: "Gibraltar", GR: "Greece", VA: "Holy See", HU: "Hungary", IE: "Ireland", IM: "Isle of Man", IT: "Italy", JE: "Jersey", LV: "Latvia", LT: "Lithuania", LU: "Luxemburg", MK: "Macedonia", MT: "Malta", MD: "Moldova", MC: "Monaco", ME: "Montenegro", MA: "Morocco", NL: "Netherlands", NO: "Norway", PL: "Poland", PT: "Portugal", RO: "Romania", RU: "Russia", SM: "San Marino", RS: "Serbia", SK: "Slovakia", SI: "Slovenia", ES: "Spain", SE: "Sweden", CH: "Switzerland", TR: "Turkey", UA: "Ukraine", GB: "United Kingdom" }, // missing: XK kosovo
            correctCountryCodes: {},
            answered: 0,
            points: 0
        };
        // var a = "";
    }

    componentWillMount() {
        this.locationState = this.props.location.state.diff;    // get difficulty props from start component
        console.log("this.locationstate: ", this.locationState)
    }

    componentDidMount() {
        console.log("THIS.STATE: ", this.props)
        console.log(this.props.diff)

        this.getSv()
        console.log(this.state.firstAnswer)
    }

    getSv() {

        this.setState({ isLoading: true });

        var lat = (Math.random() * 36.77) + 34.34;
        var lng = (Math.random() * 44.69) - 10.29;
        var viewDirection = (Math.random() * 360);

        console.log("lat: ", lat, "lng: ", lng)

        // Fetch country code of random location
        fetch("http://api.geonames.org/countryCodeJSON?lat=" + lat + "&lng=" + lng + "&username=zlavo1")
            .then((result) => {

                return result.json();
            }).then((jsonResult) => {

                console.log(jsonResult.countryCode);
                if (jsonResult.countryCode === undefined) {
                    this.getSv();
                } else {

                    this.setState({ sv: jsonResult.countryCode, lat: lat, lng: lng })
                    console.log("this.state.sv: ", this.state.sv, this.state.lat, this.state.lng)

                    // If country code exists at location -> fetch metadata of the location (=see if Google Street View exists at 500m radius of location)
                    fetch("https://maps.googleapis.com/maps/api/streetview/metadata?size=800x400&location=" + lat + "," + lng + "&fov=90&heading=" + viewDirection + "&pitch=0&radius=500&key=AIzaSyBZA0bRB2Kd2UDxf2_mngRwJdWoaAk6VIo")
                        .then((result) => {
                            return result.json();
                        }).then((jsonResult) => {
                            console.log("sv metadata: ", jsonResult.status);
                            if (jsonResult.status === "ZERO_RESULTS") {
                                this.getSv();
                            } else {
                                console.log("OK to fetch SV");
                                //this.setState({ isLoading: false })
                                this.setState({ svPath: "https://maps.googleapis.com/maps/api/streetview?size=800x400&location=" + lat + "," + lng + "&fov=90&heading=" + viewDirection + "&pitch=0&radius=500&key=AIzaSyBZA0bRB2Kd2UDxf2_mngRwJdWoaAk6VIo", isLoading: false, firstLoaded: true, clicked: false })
                                this.createButtonObject()
                            }
                        })
                }
            })
    }

    createButtonObject() {
        let buttonObject = this.state.countryCodes;     // clone object to be mutated
        let newButtonObject = {};
        let entriesToRetain = [];
        let entryKeysToRetain = [];
        let allObjectKeysInArray = [];
        let timesToLookFor = this.locationState;    // will create buttons as defined by difficulty level
        let corrEntryCode = this.state.sv
        let corrEntryNumber = 0;

        for (let i = 0; i < Object.keys(buttonObject).length; i++) {
            allObjectKeysInArray.push(Object.keys(buttonObject)[i])
        }

        console.log("allObjectKeysInArray: ", allObjectKeysInArray)

        // get number of correct entry key in object
        for (let i = 0; i < Object.keys(buttonObject).length; i++) {
            if (corrEntryCode === Object.keys(buttonObject)[i]) {
                corrEntryNumber = i;
            }
        }

        // push number of correct answer into array
        console.log("CORRECT ENTRY: ", corrEntryCode, corrEntryNumber)
        entriesToRetain.push(corrEntryNumber);

        // pick as many different random properties from the object as defined by difficulty level and push into same array where correct entry already is
        for (let i = 0; i < timesToLookFor; i++) {
            let randomEntry = Math.floor(Math.random() * Object.keys(buttonObject).length);
            if (!entriesToRetain.includes(randomEntry)) {
                entriesToRetain.push(randomEntry)
            } else {
                timesToLookFor++
            }
        }
        console.log("buttonObject ", buttonObject, "buttonObject.length ", Object.keys(buttonObject).length, "this.locationState ", this.locationState, "entriesToRetain ", entriesToRetain)

        // change selected key numbers to key names
        for (let i = 0; i < entriesToRetain.length; i++) {
            entryKeysToRetain.push(allObjectKeysInArray[entriesToRetain[i]]);
        }

        // map selected entries into a new object
        var picked = this.selectCorrectObjectKeys(buttonObject, entryKeysToRetain);

        // map correct entry to be used in render()
        var corrEntryCountry = this.selectCorrectObjectKeys(buttonObject, corrEntryCode);
        this.setState({ corrEntryCountry: Object.values(corrEntryCountry) })
        console.log("CORR ENTRY CTR ", corrEntryCountry)

        console.log("ENTRY KEYS ", entryKeysToRetain)
        // const result = Object.keys(buttonObject2).map((entriesToRetain ) => ({
        //     entriesToRetain
        //   }));

        console.log("RESULT: ", picked)

        console.log("BUTTON OBJECT ", buttonObject)
        this.setState({ correctCountryCodes: picked })
    }

    selectCorrectObjectKeys(obj, keys) {
        return Object.keys(obj)
            .filter(k => keys.includes(k))
            .map(k => Object.assign({}, { [k]: obj[k] }))
            .reduce((res, o) => Object.assign(res, o), {});
    }

    checkIfCorrect(answerCC) {
        //console.log(answerCC, this.state.sv)
        this.setState({clicked: true});
        if (answerCC === this.state.sv) {
            this.setState({ isCorrect: true, firstAnswer: true, answered: this.state.answered + 1, points: this.state.points + 1})
        } else {
            this.setState({ isCorrect: false, firstAnswer: true, answered: this.state.answered + 1})
        }
        console.log(answerCC, this.state.sv)
        setTimeout(function () { //Start the timer 
            if (this.state.answered === 10) {
                this.setState({ hasLoadedLastQuestion: true })
            }
            this.setState({ firstAnswer: false })
            this.getSv() //After 1 second, set render to true
            
        }.bind(this), 3000)
    }

    render() {

        if (this.state.hasLoadedLastQuestion) {
            return <Redirect to={{
                pathname: '/score',
                state: { points: this.state.points }
            }} />
          }

        return <div>
            <div className="imgContainer">
                <Image src={this.state.svPath} fluid rounded />
            </div>
            <br />
            <h3 className="mainText">
                {this.state.isLoading
                    ? <span>Loading...<br /><br /></span>
                    : <span>Which country?
                               <h3>
                            {!this.state.firstAnswer
                                ? <span><br /></span>
                                : <span>
                                    {this.state.isCorrect
                                        ? <span>Correct!</span>
                                        : <span>Nope! The correct answer is: {this.state.corrEntryCountry}</span>
                                    }
                                </span>}
                        </h3>
                    </span>
                }
            </h3>

            <br />
            {Object.keys(this.state.correctCountryCodes).map((keyName, i) => (
                <Button key={i} className="buttonInput" variant="outline-dark" disabled={this.state.clicked} onClick={() => this.checkIfCorrect(keyName)}>
                    <span className="buttonLabel"> {this.state.correctCountryCodes[keyName]}{/* - {keyName}*/}</span>
                </Button>
            ))}

            <br /><br />
            <p>Question {this.state.answered}/10 - Points: {this.state.points}</p>

            {!this.state.firstLoaded
                ? <span><br /></span>
                : <span>
                    <LinkContainer className="returnButton" to={{ pathname: "/" }}>
                        <Button variant="light">
                            Return to main menu
                        </Button>
                    </LinkContainer>
                </span>}

        </div>;
    }
}
